import { render, staticRenderFns } from "./ModalUsers.vue?vue&type=template&id=5354ada6&lang=pug&"
import script from "./ModalUsers.vue?vue&type=script&lang=js&"
export * from "./ModalUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports